<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>P. Edwards was born in Pontypool in South Wales, and now lives in Newport with her family and two rescue cats. She has a wide range of interests that include listening to music, travel, reading and ancient history, and she loves nothing more than to be traipsing through an ancient forest, or surrounded by some old ancient ruins somewhere. When she’s not doing any of this, she simply likes to spend some quality time with old friends or close family.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?276e0da4